import { Card } from '@components/pages/fornecedores/franchise-page/card'
import cl from 'classnames'

interface Props {
  enableTitle?: boolean
  className?: string
}

export const GroupCards = ({ enableTitle = true, className }: Props) => {
  return (
    <div>
      {!!enableTitle && (
        <h2 className="font-chivo text-4xl font-bold mt-24 mb-12 text-center">
          Conheça os nossos projetos de energia solar residencial e empresarial.
          Venha para o Portal Solar!
        </h2>
      )}
      <div className={cl(className)}>
        <Card
          image="/assets/solar-panel-solid.svg"
          imageAlt="calculadora solar"
          title="Como funciona?"
        >
          <div className="flex flex-col gap-y-5">
            <span>
              Os painéis solares captam a luz do sol e a transformam em energia
              elétrica.
            </span>
            <span>
              A eletricidade será distribuída pelo seu quadro de força, sendo
              consumida pelos equipamentos elétricos em uso.
            </span>
            <span>
              Durante o dia, o seu gerador solar produz mais energia do que será
              consumida e o excesso de energia será armazenado na rede de
              distribuição. Assim, haverá o chamamos de compensação de energia,
              ou seja, você terá energia durante dias nublados e durante todas
              as noites também.
            </span>
            <span>
              Dessa forma, você pode economizar até 90% da sua conta de luz com
              energia solar.
            </span>
          </div>
        </Card>
        <Card
          image="/assets/home-solid.svg"
          imageAlt="calculadora solar"
          title="Onde posso instalar?"
        >
          <div className="flex flex-col gap-y-5">
            <div>
              É possível instalar energia solar em quase todos os tipos de
              superfície: no solo, em telhados, lajes e até mesmo na forma
              coberturas de estacionamento.
            </div>

            <div>
              Normalmente, o telhado é a melhor opção porque possui inclinação
              necessária e está livre da incidência de sombras. Para cada tipo
              de telha existe um tipo de estrutura de fixação.
            </div>

            <div>
              Mas não se preocupe – é simples. Nós vamos buscar a melhor área
              para instalar o seu sistema fotovoltaico.
            </div>
          </div>
        </Card>
        <Card
          image="/assets/hand-holding.svg"
          imageAlt="calculadora solar"
          title="Vale a pena instalar?"
        >
          <div className="flex flex-col gap-y-5">
            <div>
              Sim! - Energia solar fotovoltaica é uma fonte de energia limpa e
              100% renovável.
            </div>
            <div>
              O seu investimento retorna em até 5 anos, e o kit gerador solar
              dura mais de 25 anos. Ou seja, você se paga em 5 anos e
              rentabiliza seu investimento em 5 vezes. É um retorno médio de 20%
              ao ano.
            </div>
            <div>
              E a melhor parte? Além do retorno de investimento, você vai
              preservar o meio-ambiente e garantir um mundo melhor!
            </div>
            <div>
              Não perca tempo! - Faça uma simulação de custo sem compromisso,
              agora!
            </div>
          </div>
        </Card>
      </div>
    </div>
  )
}
